export default "__VITE_ASSET__Ydx75oDJ__"